import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { EmotionalStory } from '../components/EmotionalStory';
import { BenefitsSection } from '../components/BenefitsSection';
import { PricingCTA } from '../components/PricingCTA';
import { TestimonialFooter } from '../components/TestimonialFooter';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-cream" data-id="element-165">
      <HeroSection data-id="element-166" />
      <EmotionalStory data-id="element-167" />
      <BenefitsSection data-id="element-168" />
      <PricingCTA data-id="element-169" />
      <TestimonialFooter data-id="element-170" />
    </main>;
}